import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"depressed":"","small":"","color":"primary","loading":_vm.loading},on:{"click":_vm.capturePayment}},[_vm._v(" "+_vm._s(_vm.t('Capture payment'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }